"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _default2 = {
  name: 'AppSelect',
  props: {
    classField: {
      type: String,
      default: ''
    },
    classInput: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    complete: {
      type: String,
      default: 'on'
    },
    placeholder: {
      type: String,
      default: ''
    },
    mask: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [String, Number, Object, Boolean],
      default: ''
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    included: {
      type: Boolean,
      default: false
    },
    option: {
      type: String,
      default: ''
    },
    nameItem: {
      type: String,
      default: ''
    },
    secondItem: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      newValue: this.value && _typeof(this.value) === 'object' ? this.value.id || '' : this.value
    };
  },
  computed: {
    computedValue: {
      get: function get() {
        return this.newValue;
      },
      set: function set(value) {
        this.newValue = value;
        this.$emit('input', value);
      }
    }
  },
  watch: {
    value: function value(_value) {
      this.newValue = _value && _typeof(_value) === 'object' ? _value.id || '' : _value;
    }
  },
  methods: {
    translateName: function translateName(item) {
      if (this.secondItem) {
        return item[this.nameItem][this.secondItem];
      }
      return item[this.nameItem];
    }
  }
};
exports.default = _default2;